// Source: app/scripts/controllers/edit-simplified-procedure-case.js
Auction.controller('EditSimplifiedProcedureCaseController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  '$route',
  '$timeout',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  'SimplifiedProcedureValidation',
  'ModalScrollLock',
  'settings',
  function ($scope, $filter, $routeParams, $location, $route, $timeout, toaster, crudService, $modal, Downloader, Messages, SimplifiedProcedureValidation, ModalScrollLock, settings) {
    var caseService = crudService('cases', {
      'getCase': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/simplified_procedure_cases/:id'
      },
      'editSimplifiedProcedureCase': {
        method: 'POST',
        url: '/data/rest/simplified_procedure_cases/edit_simplified_procedure_case'
      },
      'editSimplifiedProcedure': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/simplified_procedure/edit_simplified_procedure'
      },
      'getPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/by_case_id/:id'
      },
      'getOutgoingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_outgoing_documents_for_case_id/:id'
      },
      'getIncomingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_incoming_documents_for_case_id/:id'
      },
      'editPortalDocumentMetadata': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_documents/edit_portal_document'
      },
      'deletePortalDocument': {
        method: 'DELETE',
        url: '/data/rest/portal_documents/:id'
      },
      'getForumMessagesForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/forum/get_forum_messages/:id'
      },
      'saveForumMessage': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/forum_messages'
      },
      'submitSimplifiedProcedureCase': {
        method: 'POST',
        url: '/data/rest/simplified_procedure_cases/submit_simplified_procedure_case'
      },
      'getSimplifiedProcedureById': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/simplified_procedure/by_simplified_procedure_case_id/:id'
      },
      'getDocumentTypeByCode': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_document_types/by_code'
      }
    });

    var simplifiedProcedureGoodsService = crudService('simplified_procedure_goods', {
      'getSimplifiedProcedureGoodsForCaseId': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/simplified_procedure_goods/by_simplified_procedure_case_id/:id'
      }
    });

    var authorizationCaseService = crudService('authorization_cases', {
      'findTariffByCode': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/tariffs/by_code'
      }
    });

    // var iprRightsService = crudService('ipr_rights', {
    //   'getIprRightsForCaseId': {
    //     method: 'GET',
    //     isArray: true,
    //     url: '/data/rest/ipr_rights/by_ipr_case_id/:id'
    //   },
    //   'addIprRightsToIPRCase': {
    //     method: 'POST',
    //     url: '/data/rest/ipr_rights/add_ipr_rights_to_ipr_case'
    //   },
    //   'deleteIprRights': {
    //     method: 'DELETE',
    //     url: '/data/rest/ipr_rights/:id'
    //   },
    //   'saveIprRights': {
    //     method: 'POST',
    //     isArray: 'true',
    //     url: '/data/rest/ipr_rights/save_rights'
    //   }
    // });
    //
    // var iprGoodsService = crudService('ipr_goods', {
    //   'getIprGoodsForCaseId': {
    //     method: 'GET',
    //     isArray: true,
    //     url: '/data/rest/ipr_goods/by_ipr_case_id/:id'
    //   },
    //   'addIprGoodsToIPRCase': {
    //     method: 'POST',
    //     url: '/data/rest/ipr_goods/add_ipr_goods_to_ipr_case'
    //   },
    //   'deleteIprGoods': {
    //     method: 'DELETE',
    //     url: '/data/rest/ipr_goods/:id'
    //   },
    //   'saveIprGoods': {
    //     method: 'POST',
    //     isArray: 'true',
    //     url: '/data/rest/ipr_goods/save_goods'
    //   }
    // });

    var forumService = crudService('forum', {
        'getForumMessagesForCase': {
          method: 'GET',
          isArray: true,
          url: '/data/rest/forum/get_forum_messages/:id'
        },
        'saveForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        },
        'submitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages/submit_forum_message'
        },
        'deleteForumMessage': {
          method: 'DELETE',
          isArray: false,
          url: '/data/rest/forum_messages/:id'
        },
        'saveAndSubmitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        }

      }
    );
    if ($routeParams && $routeParams.recordsTab) {
      $scope.recordsTab = $routeParams.recordsTab;
    }

    $scope.activateTab = function (rt) {
      var search = {
        recordsTab: rt
      };

     $scope.recordsTab = rt;
    };

    if ($routeParams && $routeParams.recordsDocumentTab) {
      $scope.recordsDocumentTab = $routeParams.recordsDocumentTab;
    }

    $scope.activateDocumentTab = function (rt) {
      var search = {
        recordsDocumentTab: rt
      };
      $scope.recordsDocumentTab = rt;
    };


    function syncSimplifiedProcedureAuthorizedPersonForm() {
      $scope.authorizedPersonFormEntity = $scope.simplifiedProcedure || {};
    }

    function loadSimplifiedProcedureData(caseId) {
      caseService.getSimplifiedProcedureById({id: caseId}, function (data) {
        $scope.simplifiedProcedure = data || {};
        syncSimplifiedProcedureAuthorizedPersonForm();
        simplifiedProcedureGoodsService.getSimplifiedProcedureGoodsForCaseId({id: caseId}, function (goods) {
          if (!$scope.simplifiedProcedureCaseEntity) {
            $scope.simplifiedProcedureCaseEntity = {};
          }
          $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList = goods || [];
        });
      });
    }

    function initEntity() {
      $scope.editingRightIndex = -1;
      $scope.editingGoodIndex = -1;
      var portalCase;
      caseService.getCase({id: $routeParams.id}, function (data) {

        portalCase = data;
        if(portalCase.caseStatus != 'DRAFT' && portalCase.caseStatus != 'RETURNED_FOR_CORRECTIONS'){
          $scope.viewSimplifiedProcedureCase(portalCase.id);
        }
        $scope.allowEdit = true;
        $scope.entity = {};
        $scope.entity.portalCase = portalCase;
        $scope.forum = portalCase.forum;
        $scope.newForumMessage = {};
        $scope.authorizationTariff = {};
        $scope.foundAuthorizationTafiff = "";
        $scope.simplifiedProcedure = {};
        syncSimplifiedProcedureAuthorizedPersonForm();
        // $scope.iprRights = {};
        // $scope.iprGoods = {};
        //$scope.iprRightsList = {};
        $scope.simplifiedProcedureCaseEntity = {};
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList = [];
        // $scope.iprCaseEntity.iprRightsList = [];
        // $scope.iprCaseEntity.iprGoodsList = [];
        // $scope.onEditRight = false;
        // $scope.onEditGood = false;
        $scope.chosenDocument = {};
        $scope.portalDocument = {};
        if (portalCase.aboutIndividual) {
          $scope.entity.forCompany = 0;
          $scope.entity.forIndividual = 1;
          $scope.forCompany = 0;
          $scope.forIndividual = 1;
          $scope.individual = portalCase.aboutIndividual;
        } else {
          $scope.entity.forCompany = 1;
          $scope.entity.forIndividual = 0;
          $scope.forCompany = 1;
          $scope.forIndividual = 0;
          $scope.company = portalCase.aboutCompany;

        }
        $scope.activateTab(1);
        loadSimplifiedProcedureData($scope.entity.portalCase.id);
        caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
          $scope.outgoingDocumentList = data;
          $scope.activateDocumentTab(1);
          caseService.getIncomingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.incomingDocumentList = data;
            caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
              $scope.forumMessagesList = data;
            });
          });
        });
      });


    }


    initEntity();


    $scope.editCase = function (portalCase) {
      caseService.editSimplifiedProcedureCase(portalCase, function (data) {
        $scope.entity.portalCase = portalCase;
        Messages.saved();
      })
    };


    $scope.downloadDocument = function () {
      if ($scope.chosenDocument.id) {
        Downloader.download('/data/rest/portal_attachments/get/' + $scope.chosenDocument.id);
      }
    };

    $scope.saveChosenDocumentMetadata = function () {
      if ($scope.chosenDocument.id) {
        caseService.editPortalDocumentMetadata(
          {
            id:  $scope.chosenDocument.id,
            description:  $scope.chosenDocument.description,
            typeId: $scope.chosenDocument.documentType.id
          }, function (data) {
            $scope.chosenDocument = data;
            Messages.saved();
          })
      }
    };


    $scope.outgoingDocumentsIndeks = -1;
    $scope.incomingDocumentsIndeks = -1;
    $scope.chooseOutgoingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.outgoingDocumentsIndeks = index;
      $scope.incomingDocumentsIndeks = -1;
    };
    $scope.chooseIncomingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.incomingDocumentsIndeks = index;
      $scope.outgoingDocumentsIndeks = -1;
    };


    $scope.modalAddOrEditSimplifiedProcedureRequiredDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_simplified_procedure_required_document.html',
      show: false
    });

    $scope.modalAddOrEditCaseDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_case_document.html',
      show: false
    });

    $scope.modalSubmitCaseConfirm = $modal({
      scope: $scope,
      template: 'templates/forum-form.tpl.html',
      contentTemplate: 'forms/modals/submit_case_confirm.html',
      show: false
    });

    $scope.modalAddOrEditSimplifiedProcedureGood = $modal({
      scope: $scope,
      template: 'forms/add_or_edit_simplified_procedure_goods.html?version=' + settings.version,
      show: false,
      windowClass: 'my-large-modal'
    });

    $scope.ensureSimplifiedProcedureGoodsList = function () {
      if (!$scope.simplifiedProcedureCaseEntity) {
        $scope.simplifiedProcedureCaseEntity = {};
      }
      if (!$scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList) {
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList = [];
      }
    };

    $scope.searchTariffByCodeForSimplifiedProcedureGood = function (code) {
      authorizationCaseService.findTariffByCode({code: code}, function (data) {
        if (data.id) {
          $scope.simplifiedProcedureGoodEntity.tariff = data;
          $scope.simplifiedProcedureGoodEntity.tariffCode = code;
          $scope.simplifiedProcedureGoodEntity.tariffDescription = data.labelSQ;
          $scope.foundSimplifiedProcedureTariffMessage = '';
        } else {
          $scope.simplifiedProcedureGoodEntity.tariff = null;
          $scope.simplifiedProcedureGoodEntity.tariffDescription = null;
          $scope.foundSimplifiedProcedureTariffMessage = 'portal.tariff_not_found';
        }
      });
    };

    $scope.saveSimplifiedProcedureGoodFromModal = function () {
      var entity = $scope.simplifiedProcedureGoodEntity;
      if (!entity.tariff || !entity.tariff.id) {
        Messages.error('portal.invalid_tariff');
        return;
      }

      var good = {
        tariffCode: entity.tariffCode,
        tariffDescription: entity.tariffDescription || entity.tariff.labelSQ,
        goodCustomsProcedures: entity.goodCustomsProcedures,
        countries: entity.countries,
        codeOfProcedures: entity.codeOfProcedures,
        parities: entity.parities,
        packagingMethods: entity.packagingMethods,
        exporter: entity.exporter,
        tariff: entity.tariff
      };

      $scope.ensureSimplifiedProcedureGoodsList();

      if ($scope.onEditSimplifiedProcedureGood && $scope.editingSimplifiedProcedureGoodIndex !== -1) {
        good.id = $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList[$scope.editingSimplifiedProcedureGoodIndex].id;
        angular.copy(good, $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList[$scope.editingSimplifiedProcedureGoodIndex]);
      } else {
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList.push(good);
      }

      Messages.saved();
      $scope.modalAddOrEditSimplifiedProcedureGood.hide();
      $scope.onEditSimplifiedProcedureGood = false;
      $scope.editingSimplifiedProcedureGoodIndex = -1;
      $scope.simplifiedProcedureGoodEntity = {};
      $scope.foundSimplifiedProcedureTariffMessage = '';
    };

    $scope.cancelSimplifiedProcedureGoodModal = function () {
      $scope.modalAddOrEditSimplifiedProcedureGood.hide();
      $scope.onEditSimplifiedProcedureGood = false;
      $scope.editingSimplifiedProcedureGoodIndex = -1;
      $scope.simplifiedProcedureGoodEntity = {};
      $scope.foundSimplifiedProcedureTariffMessage = '';
    };

    $scope.addNewSimplifiedProcedureGood = function () {
      $scope.ensureSimplifiedProcedureGoodsList();
      $scope.onEditSimplifiedProcedureGood = false;
      $scope.editingSimplifiedProcedureGoodIndex = -1;
      $scope.simplifiedProcedureGoodEntity = {goodCustomsProcedures: [], countries: [], codeOfProcedures: [], parities: [], packagingMethods: []};
      $scope.foundSimplifiedProcedureTariffMessage = '';
      $scope.modalAddOrEditSimplifiedProcedureGood.show();
    };

    $scope.editSimplifiedProcedureGood = function (index) {
      $scope.ensureSimplifiedProcedureGoodsList();
      $scope.onEditSimplifiedProcedureGood = true;
      $scope.editingSimplifiedProcedureGoodIndex = index;
      $scope.simplifiedProcedureGoodEntity = angular.copy($scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList[index]);
      $scope.simplifiedProcedureGoodEntity.goodCustomsProcedures = $scope.simplifiedProcedureGoodEntity.goodCustomsProcedures || [];
      $scope.simplifiedProcedureGoodEntity.countries = $scope.simplifiedProcedureGoodEntity.countries || [];
      $scope.simplifiedProcedureGoodEntity.codeOfProcedures = $scope.simplifiedProcedureGoodEntity.codeOfProcedures || [];
      $scope.simplifiedProcedureGoodEntity.parities = $scope.simplifiedProcedureGoodEntity.parities || [];
      $scope.simplifiedProcedureGoodEntity.packagingMethods = $scope.simplifiedProcedureGoodEntity.packagingMethods || [];
      $scope.foundSimplifiedProcedureTariffMessage = '';
      if ($scope.simplifiedProcedureGoodEntity.tariffCode) {
        authorizationCaseService.findTariffByCode({code: $scope.simplifiedProcedureGoodEntity.tariffCode}, function (data) {
          if (data.id) {
            $scope.simplifiedProcedureGoodEntity.tariff = data;
          }
        });
      }
      $scope.modalAddOrEditSimplifiedProcedureGood.show();
    };

    $scope.removeSimplifiedProcedureGoods = function (index) {
      $scope.ensureSimplifiedProcedureGoodsList();
      $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList.splice(index, 1);
    };

    $scope.prepareSimplifiedProcedureGoodsForSave = function () {
      return ($scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList || []).map(function (good) {
        return {
          id: good.id,
          tariffCode: good.tariffCode,
          tariffDescription: good.tariffDescription,
          goodCustomsProcedures: (good.goodCustomsProcedures || []).map(function (item) {
            return {id: item.id, code: item.code};
          }),
          countries: (good.countries || []).map(function (item) {
            return {id: item.id, code: item.code};
          }),
          codeOfProcedures: (good.codeOfProcedures || []).map(function (item) {
            return {id: item.id, code: item.code};
          }),
          parities: (good.parities || []).map(function (item) {
            return {id: item.id, code: item.code};
          }),
          packagingMethods: (good.packagingMethods || []).map(function (item) {
            return {id: item.id, code: item.code};
          }),
          exporter: good.exporter
        };
      });
    };

    // var rightScope = $scope.$new(true);
    // var addOrEditRightDialog = $modal({
    //   scope: rightScope,
    //   template: 'forms/add_or_edit_ipr_rights.html',
    //   show: false,
    //   windowClass: 'my-small-modal'
    // });
    //
    // rightScope.$watch('rightEntity', function (newVal) {
    //   if (!newVal) return;
    //
    //   var selectedGoods = [];
    //
    //   // Поминуваме низ сите 45 полиња од HTML-от (referredItem1 до referredItem45)
    //   for (var i = 1; i <= 45; i++) {
    //     var propertyName = 'referredItem' + i;
    //     // Ако чекбоксот е штиклиран во rightEntity
    //     if (newVal[propertyName] === true) {
    //       selectedGoods.push(i);
    //     }
    //   }
    //
    //   // Автоматски го пополнуваме referredList со броевите (пр. "1, 2, 5")
    //   // Ова веднаш ќе се рефлектира во input полето во HTML-от
    //   rightScope.rightEntity.referredList = selectedGoods.join(', ');
    //
    // }, true);
    //
    // var goodScope = $scope.$new(true);
    // var addOrEditGoodDialog = $modal({
    //   scope: goodScope,
    //   template: 'forms/add_or_edit_ipr_goods.html',
    //   show: false,
    //   windowClass: 'my-large-modal'
    // });

    $scope.showAddNewDocumentForm = function () {
      $scope.portalDocument = {};
      $scope.modalAddOrEditCaseDocument.show();
    };

    $scope.changeAttachmentForDocument = function () {
      if ($scope.chosenDocument.id) {
        $scope.portalDocument = $scope.chosenDocument;
        $scope.modalAddOrEditSimplifiedProcedureRequiredDocument.show();
      }
    };

    $scope.savePortalDocument = function () {
      caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
        $scope.outgoingDocumentList = data;
      });
      $scope.modalAddOrEditCaseDocument.hide();

      $scope.portalDocument = {};

    };


    $scope.showAddNewSimplifiedProcedureRequiredDocForm = function () {
        caseService.getDocumentTypeByCode({code: 'SIMPLIFIED_PROCEDURE_REQUIRED'}, function (data) {
          $scope.portalDocument = {};
          $scope.portalDocument.documentType = data;
          $scope.modalAddOrEditSimplifiedProcedureRequiredDocument.show();
        });

    };


    $scope.deletePortalDocument = function () {
      if ($scope.chosenDocument.id) {
        caseService.deletePortalDocument({id: $scope.chosenDocument.id}, function () {
          caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.outgoingDocumentList = data;
            Messages.deleted();
            $scope.chosenDocument = {};
          });
        })
      }

    };

    $scope.saveForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      caseService.saveForumMessage(forumMessage, function (data) {
        caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })

    };


    $scope.submitForumMessage = function (forumMessage) {
      forumService.submitForumMessage(forumMessage.id, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };


    $scope.saveAndSubmitForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      forumService.saveForumMessage(forumMessage, function (data) {
        $scope.forumMessage2 = data;
        forumService.submitForumMessage(data.id, function (data) {
          forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
            $scope.forumMessagesList = data;
            $scope.newForumMessage = {};
          });
        });
      });
    };

    $scope.deleteForumMessage = function (forumMessage) {
      forumService.deleteForumMessage({id: forumMessage.id}, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };

    $scope.openSubmitForm = function(portalCase){
      $scope.portalCase = portalCase;
      $scope.modalSubmitCaseConfirm.show();
    };

    $scope.submitPortalCase = function (id) {

      caseService.submitSimplifiedProcedureCase(id, function (data) {
        Messages.saved();
        $scope.modalSubmitCaseConfirm.hide();
        ModalScrollLock.release();
        $location.path("/web_portal/web_portal_home_page/view_simplified_procedure_case/" + id);
        $timeout(function () {
          ModalScrollLock.release();
          $route.reload();
        });
      });

    };

    // $scope.addNewIprRight = function () {
    //   $scope.onEditRight = false;
    //   $scope.editingRightIndex = -1;
    //   rightScope.rightEntity = {};
    //   addOrEditRightDialog.show();
    // }
    //
    // $scope.addNewIprGood = function () {
    //   $scope.onEditGood = false;
    //   $scope.editingGoodIndex = -1;
    //   goodScope.goodEntity = {};
    //   addOrEditGoodDialog.show();
    // }
    //
    // rightScope.ok = function () {
    //   if ($scope.onEditRight===false) {
    //     $scope.iprCaseEntity.iprRightsList.push(rightScope.rightEntity);
    //     Messages.saved();
    //   } else {
    //     if ($scope.editingRightIndex !== -1) {
    //       angular.copy(rightScope.rightEntity, $scope.iprCaseEntity.iprRightsList[$scope.editingRightIndex]);
    //       Messages.saved();
    //     } else {
    //       Messages.error('portal.error');
    //     }
    //   }
    //   addOrEditRightDialog.hide();
    //   $scope.onEditRight=false;

    // };


    // rightScope.cancel = function () {
    //   addOrEditRightDialog.hide();
    // };
    //
    // goodScope.ok = function () {
    //   if ($scope.onEditGood===false) {
    //     $scope.iprCaseEntity.iprGoodsList.push(goodScope.goodEntity);
    //     Messages.saved();
    //   } else {
    //     if ($scope.editingGoodIndex !== -1) {
    //       angular.copy(goodScope.goodEntity, $scope.iprCaseEntity.iprGoodsList[$scope.editingGoodIndex]);
    //       Messages.saved();
    //     } else {
    //       Messages.error('portal.error');
    //     }
    //   }
    //   addOrEditGoodDialog.hide();
    //   $scope.onEditGood=false;
    //
    // };
    //
    //
    // goodScope.cancel = function () {
    //   addOrEditGoodDialog.hide();
    // };
    //
    //
    // $scope.addIPRRights = function (iprRights) {
    //   var counter = $scope.iprRights.length;
    //
    //   if(iprRights.rightNumber){
    //     $scope.iprRightsList.splice(iprRights.itemNumber-1, 1);
    //   }else{
    //     iprRights.rightNumber = $scope.iprRightsList.length+1;
    //   }
    //   $scope.iprRightsList.splice(iprRights.rightNumber-1, 0, iprRights);
    //   $scope.iprRights = {};
    // };
    //
    // $scope.removeIPRRights = function (item) {
    //   var index = item;
    //   $scope.iprRightsList.splice(index, 1);
    // };
    //
    // $scope.addIPRGoods = function (iprGoods) {
    //   var counter = $scope.iprGoods.length;
    //
    //   if(iprGoods.rightNumber){
    //     $scope.iprGoodsList.splice(iprGoods.itemNumber-1, 1);
    //   }else{
    //     iprGoods.rightNumber = $scope.iprGoodsList.length+1;
    //   }
    //   $scope.iprGoodsList.splice(iprGoods.rightNumber-1, 0, iprGoods);
    //   $scope.iprGoods = {};
    // };
    //
    // $scope.removeIPRGoods = function (item) {
    //   var index = item;
    //   $scope.iprGoodsList.splice(index, 1);
    // };
    //
    //
    // $scope.editIprRight = function (item) {
    //   $scope.onEditRight=true;
    //   var index = item;
    //   $scope.editingRightIndex = index;
    //   rightScope.rightEntity = angular.copy($scope.iprRightsList[index]);
    //   addOrEditRightDialog.show();
    // };
    //
    // $scope.editIprGood = function (item) {
    //   $scope.onEditGood=true;
    //   var index = item;
    //   $scope.editingGoodIndex = index;
    //   goodScope.goodEntity = angular.copy($scope.iprGoodsList[index]);
    //   addOrEditGoodDialog.show();
    // };

    $scope.editSimplifiedProcedure = function (simplifiedProcedure) {
      if (!SimplifiedProcedureValidation.validateAndNotify(simplifiedProcedure)) {
        return;
      }

      $scope.ensureSimplifiedProcedureGoodsList();

      $scope.entityForUpdate = {};
      $scope.entityForUpdate.simplifiedProcedure = simplifiedProcedure || {};
      if ($scope.entity.portalCase && $scope.entity.portalCase.id) {
        $scope.entityForUpdate.simplifiedProcedure.simplifiedProcedureCase = {id: $scope.entity.portalCase.id};
      }
      $scope.entityForUpdate.simplifiedProcedureGoodsList = $scope.prepareSimplifiedProcedureGoodsForSave();

      caseService.editSimplifiedProcedure($scope.entityForUpdate, function (data) {
        $scope.simplifiedProcedure = data;
        syncSimplifiedProcedureAuthorizedPersonForm();
        simplifiedProcedureGoodsService.getSimplifiedProcedureGoodsForCaseId({id: $scope.entity.portalCase.id}, function (goods) {
          $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList = goods || [];
          Messages.saved();
          $scope.activateTab(1);
        });
      });

    };

    $scope.viewSimplifiedProcedureCase = function (id) {
      $location.path("/web_portal/web_portal_home_page/view_simplified_procedure_case/" + id);
    };


  }
]);
